import { ReactNode } from "react";
import { Box, Typography } from "@mui/material";

export default function SettingRow({
  label,
  description,
  control,
  align = "center",
}: {
  label: string;
  description?: ReactNode;
  control: ReactNode;
  align?: "center" | "flex-start";
}) {
  return (
    <Box sx={{ display: "flex", alignItems: align, justifyContent: "space-between", gap: 3, py: 2 }}>
      <Box>
        <Typography sx={{ fontWeight: 600 }}>{label}</Typography>
        {description && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {description}
          </Typography>
        )}
      </Box>
      <Box sx={{ flexShrink: 0 }}>{control}</Box>
    </Box>
  );
}
